import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchImportHistory, getImportFile } from 'redux/importHistory/ImportHistoryActions';
import ImportHistoryGrid from './ImportHistoryGrid';
import { MONTHS } from 'shared/components/monthPicker/helpers/monthPickerConstants';

const mapStateToProps = ({ importHistory }) => ({
  importHistoryData: importHistory.importHistoryData.map(history => ({ ...history, period: `${ history.period.substr(0, 4) } - ${ MONTHS[parseInt(history.period.substr(4, 2)) - 1] }` })),
  importHistoryStatusData: importHistory.importHistoryStatusData,
  totalItems: importHistory.pageState.totalEntries,
  fetchingImportHistory: importHistory.fetchingImportHistory
});

const mapDispatchToProps = dispatch => ({
  importHistoryActions: bindActionCreators({ fetchImportHistory, getImportFile }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportHistoryGrid);



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/comp/importHistoryGrid/ImportHistoryGridConnector.js